import styled from '@emotion/styled'
import { colors, typography } from '@resiliatech/birdsong'
import { Button, IconButton } from '@mui/material'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
`

export const HeaderRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 3fr) minmax(0, 2fr) minmax(0, 1fr) 60px;
  align-items: center;
  padding: 16px;
  background-color: #f5f5f5;
  border-bottom: 1px solid ${colors.interactive.secondaryHoverFocus};
`

export const HeaderCell = styled.div`
  ${typography.down1.semiBoldSans}
  color: ${colors.text.primary};
  padding: 0 8px;
`

export const ScrollableContent = styled.div`
  max-height: 360px;
  overflow-y: auto;
  width: 100%;
`

export const AttachmentRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 3fr) minmax(0, 2fr) minmax(0, 1fr) 60px;
  align-items: center;
  padding: 16px;
  background-color: white;
  border-bottom: 1px solid ${colors.background.primaryBackground};

  &:hover {
    background-color: ${colors.background.secondaryBackground};
  }
`

export const AttachmentCell = styled.div`
  padding: 0 8px;
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const FileNameCell = styled(AttachmentCell)`
  gap: 12px;
`

export const UserCell = styled(AttachmentCell)`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const DateCell = styled(AttachmentCell)`
  ${typography.down1.regularSans}
  color: ${colors.text.secondary};
`

export const ActionsCell = styled(AttachmentCell)`
  justify-content: center;
`

export const AttachmentIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #f0f0f0;
  border-radius: 4px;
  flex-shrink: 0;
`

export const FileName = styled.div`
  ${typography.baseline.regularSans}
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const UserAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  ${typography.down2.semiBoldSans}
  color: #555;
  flex-shrink: 0;
`

export const UserInfo = styled.div`
  ${typography.baseline.regularSans}
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ActionsButton = styled(IconButton)`
  padding: 4px;
`

export const UploadButton = styled(Button)`
  margin-left: auto;
  margin-bottom: 16px;
  border-radius: 20px !important;
`

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  width: 100%;
  min-height: 300px;
`

export const IconContainer = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
`

export const EmptyStateTitle = styled.div`
  font-family: 'Helvetica Neue' !important;
  font-size: 18px;
  margin-bottom: 10px;
`

export const EmptyStateText = styled.p`
  font-family: 'Helvetica Neue' !important;
  font-size: 16px;
  margin-bottom: 24px;
  max-width: 500px;
`
